function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css",
  id: "style835"
}, ".logo-mobile_inline_svg__st0{fill:#00467f}.logo-mobile_inline_svg__st1{fill:#fff}.logo-mobile_inline_svg__st2{fill:#49a942}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M58.6 31.4c0 15.4-12.5 27.9-27.9 27.9-15.4 0-27.9-12.5-27.9-27.9C2.8 16 15.3 3.5 30.7 3.5c15.4 0 27.9 12.5 27.9 27.9m2.1.1c0-16.6-13.4-30-30-30s-30 13.4-30 30 13.4 30 30 30 30-13.4 30-30",
  id: "logo-mobile_inline_svg__path837"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st1",
  d: "M37.9 5.7c-.2.1-.1-.2-.4-.1.7.8.3 2.1.9 3 4.3 6.6 5.5 14.3 4 21.6-1.4 7.3-.1 14.8 4.2 21.3.1.2.8 1 .9 1.2 5.9-4.9 9.9-13 9.9-21.3.1-12.3-8.2-22.6-19.5-25.7",
  id: "logo-mobile_inline_svg__path839"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st1",
  d: "M27.5 9.2C26.9 8 25.8 6.5 25 5.5c-2.8.3-6.5 3.2-9.5 3.9.6.8.4 1.7.9 2.6 3.4 6.5 3.7 13.9 1.4 20.8-2.3 6.8-1.9 14.1 1.5 20.6.7 1.3 1.5 2.5 2.3 3.6 2.9-.5 4.3 1.1 7.1-.3.1-.1 2 1.8 2.1 1.8-.6-.9.1-6.3-.5-7.3C27.1 45 26.8 38 29 31.5c2.2-6.6 1.8-16.1-1.5-22.3",
  id: "logo-mobile_inline_svg__path841"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st2",
  d: "M24.7 9c0-1.2-.1-2.4-.3-3.6C12.7 8.3 4 18.8 4 31.4c0 1.2.1 2.4.3 3.6.8 5.6 3.2 10.6 6.8 14.5-.2-1.4-.4-2.9-.4-4.3 0-7 2.5-13.3 6.9-18C22 22.4 24.7 16 24.7 9",
  id: "logo-mobile_inline_svg__path843"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M22.4 56.9h.2c-.1 0-.1 0-.2-.1-.1 0-.1.1 0 .1zm2.9-50c.1.7.1 1.5.1 2.1 0 6.1-2 11.7-5.5 16.2-.1 2.6-.6 5.1-1.5 7.6-2.3 6.8-1.9 14.1 1.5 20.6.4.8.8 1.5 1.3 2.1-.4-1.2-.9-2.4-.9-3.6 0-8.2 2.9-15.5 8-21.1 1.9-6.5 1.5-15.6-1.7-21.5-.2-.9-.7-1.7-1.3-2.4zm21.5 3.2c.2 1.3.3 2.6.3 3.9 0 5.2-1.3 10.1-3.6 14.4l-.3 1.8c-1.4 7.3-.1 14.8 4.2 21.3.1.2.3.4.4.5 5.9-4.9 9.7-12.3 9.7-20.6 0-8.7-4.2-16.4-10.7-21.3zM30.5 58.2h-.1c.1.1.3.2.3.2s-.1-.1-.1-.2h-.1z",
  id: "logo-mobile_inline_svg__path845"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st2",
  d: "M46.4 14c0-1.5-.1-3-.4-4.4-2.4-2.5-5.6-3.8-8.4-4 .1 1.1.2 2.3.2 3.5 0 8.3-3.2 15.8-8.4 21.4-5.2 5.6-8.2 13-8.2 21.3 0 1.6.2 3.2.4 4.8 2.8 1 5.8 1.6 8.9 1.6h.4c-.1-1.2-.3-2.4-.3-3.6 0-7.8 3-15 8-20.3 4.9-5.4 7.8-12.4 7.8-20.3",
  id: "logo-mobile_inline_svg__path847"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M79 31.4v-.7c1.5-.2 1.6-.3 1.6-2.1v-7.7h-.1l-4.4 10.4h-.6l-4.1-10.2h-.1l-.2 5.2c-.1 1.7-.1 2.6 0 3.2.1.9.5 1.1 1.8 1.2v.7h-4.8v-.7c1.1-.1 1.5-.4 1.6-1.2.1-.6.3-1.7.4-3.8l.3-4c.2-2.3 0-2.5-1.7-2.7v-.7h4.1l3.8 8.8 3.9-8.8h4v.7c-1.6.2-1.7.3-1.6 2l.2 7.5c0 1.8.1 2 1.7 2.1v.7H79z",
  id: "logo-mobile_inline_svg__path849"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M93.5 31.4v-.7c1.2-.2 1.3-.4 1-1.3-.2-.6-.5-1.5-.8-2.3h-3.9c-.2.6-.5 1.3-.7 2.1-.3 1-.2 1.2 1.2 1.4v.7h-4.5v-.7c1.3-.2 1.6-.4 2.2-2.1l4.1-10.3 1-.3c1.3 3.5 2.5 7 3.8 10.4.7 1.8.9 2 2.2 2.2v.7h-5.6zm-1.7-9.6h-.1c-.6 1.5-1.1 2.9-1.6 4.3h3.1l-1.4-4.3z",
  id: "logo-mobile_inline_svg__path851"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M112.8 19.1c-1.1.1-1.6.5-1.7 1.2-.1.6-.2 1.4-.2 2.8v2.2c0 2.1-.3 3.8-1.4 5-.9 1-2.3 1.5-3.7 1.5-1.3 0-2.6-.3-3.5-1-1.1-.9-1.7-2.4-1.7-4.7v-4.7c0-1.9-.2-2-1.7-2.1v-.7h6v.7c-1.5.1-1.7.3-1.7 2.1v4.4c0 3 1.1 4.7 3.2 4.7 2.4 0 3.4-1.8 3.4-5.1v-2.1c0-1.4-.1-2.2-.2-2.8-.1-.7-.6-1.1-1.9-1.2v-.7h5v.5z",
  id: "logo-mobile_inline_svg__path853"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M126 31.6h-.6c-2.5-.1-3.3-.7-4.1-1.9-.5-.8-1.1-1.9-1.6-3-.3-.6-.7-.9-1.3-.9h-.4v2.9c0 1.7.2 1.8 1.7 2v.7h-6v-.7c1.5-.1 1.7-.3 1.7-2V21c0-1.6-.2-1.8-1.6-1.9v-.7h5.6c1.8 0 2.8.2 3.6.7.8.5 1.3 1.4 1.3 2.7 0 1.8-1.2 2.7-2.5 3.3.3.6 1 1.9 1.6 2.8.7 1.1 1.1 1.8 1.5 2.2.4.5.8.7 1.2.9l-.1.6zm-7.5-6.6c.8 0 1.5-.1 2-.5.7-.6 1-1.4 1-2.4 0-2.1-1.2-2.9-2.4-2.9-.5 0-.8.1-.9.2-.1.1-.2.3-.2.7V25h.5z",
  id: "logo-mobile_inline_svg__path855"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M138 19.1c-1.3.1-1.7.5-2.4 1.7s-1.3 2-2.2 3.9c-.3.5-.4.8-.4 1.4v2.6c0 1.8.1 1.9 1.9 2.1v.7h-6.5v-.7c1.7-.1 1.9-.3 1.9-2.1v-2.2c0-.5-.1-.7-.3-1.1-.5-1.1-1.3-2.4-2.5-4.5-.7-1.3-1.1-1.5-2.2-1.7v-.7h5.7v.7c-1.3.2-1.3.4-.9 1.1.7 1.4 1.5 2.9 2.3 4.4.6-1.1 1.6-3 2.1-4.2.3-.8.3-1.1-1.2-1.3v-.7h4.7v.6z",
  id: "logo-mobile_inline_svg__path857"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M155.6 31.6h-.6c-2.5-.1-3.3-.7-4.1-1.9-.5-.8-1.1-1.9-1.6-3-.3-.6-.7-.9-1.3-.9h-.4v2.9c0 1.7.2 1.8 1.7 2v.7h-6v-.7c1.5-.1 1.7-.3 1.7-2V21c0-1.6-.2-1.8-1.6-1.9v-.7h5.6c1.8 0 2.8.2 3.6.7.8.5 1.3 1.4 1.3 2.7 0 1.8-1.2 2.7-2.5 3.3.3.6 1 1.9 1.6 2.8.7 1.1 1.1 1.8 1.5 2.2.4.5.8.7 1.2.9l-.1.6zm-7.5-6.6c.8 0 1.5-.1 2-.5.7-.6 1-1.4 1-2.4 0-2.1-1.2-2.9-2.4-2.9-.5 0-.8.1-.9.2-.1.1-.2.3-.2.7V25h.5z",
  id: "logo-mobile_inline_svg__path859"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M167.1 28.1c-.1.9-.5 2.7-.7 3.3h-10.2v-.7c1.7-.1 1.9-.3 1.9-2V21c0-1.7-.2-1.8-1.6-2v-.7h9.4c0 .4.1 1.8.2 3l-.7.1c-.2-.7-.4-1.4-.8-1.7-.3-.4-.9-.5-2-.5h-1c-.7 0-.8 0-.8.7v4.2h1.3c1.7 0 2-.1 2.2-1.5h.7v4h-.7c-.3-1.4-.5-1.5-2.2-1.5h-1.3v3.5c0 1 .1 1.4.5 1.6.4.2 1 .2 1.8.2 1 0 1.7-.1 2.2-.6.4-.4.8-1.1 1.1-2l.7.3z",
  id: "logo-mobile_inline_svg__path861"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M181.4 25.9c-1 .2-1.1.3-1.1 1.6v1.6c0 .7 0 1.4.1 1.9-1.2.3-2.9.7-4.6.7-4.6 0-7.6-2.6-7.6-6.7 0-4.6 3.7-6.9 7.9-6.9 1.6 0 3.2.4 3.9.6.1.7.2 1.7.3 3.3l-.8.2c-.5-2.2-2-3.2-3.9-3.2-2.4 0-4.5 2.2-4.5 5.8 0 3 1.5 6.2 4.8 6.2.4 0 .9-.1 1.1-.2.3-.2.5-.5.5-1.1v-1.9c0-1.4-.1-1.6-2.2-1.7v-.7h6v.5z",
  id: "logo-mobile_inline_svg__path863"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M182.6 31.4v-.7c1.5-.1 1.7-.3 1.7-2V21c0-1.7-.2-1.8-1.7-2v-.7h6v.7c-1.5.1-1.7.3-1.7 2v7.7c0 1.7.2 1.8 1.7 2v.7h-6z",
  id: "logo-mobile_inline_svg__path865"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M203.7 24.8c0 4.3-3.1 6.9-6.9 6.9-4 0-6.8-2.9-6.8-6.8 0-3.4 2.5-6.8 7-6.8 3.7.1 6.7 2.8 6.7 6.7zm-10.6-.2c0 3.4 1.5 6.3 4.1 6.3 1.9 0 3.4-1.9 3.4-5.5 0-4-1.6-6.4-3.9-6.4-2 0-3.6 2.1-3.6 5.6z",
  id: "logo-mobile_inline_svg__path867"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M218.8 19.1c-1.1.1-1.5.3-1.6 1.2-.1.6-.2 1.6-.2 3.3v7.9h-1l-8.3-10h-.1V26c0 1.8.1 2.7.2 3.3.1.9.4 1.3 1.9 1.3v.7h-4.9v-.7c1.1-.1 1.6-.4 1.7-1.3.1-.7.2-1.6.2-3.3v-4.2c0-1.3 0-1.7-.4-2.2-.4-.5-.8-.6-1.7-.7v-.7h3.7L216 27h.1v-3.5c0-1.8-.1-2.7-.2-3.3-.1-.9-.5-1.2-2-1.3v-.7h4.9v.9z",
  id: "logo-mobile_inline_svg__path869"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M226.2 31.4v-.7c1.2-.2 1.3-.4 1-1.3-.2-.6-.5-1.5-.8-2.3h-3.8c-.2.6-.5 1.3-.7 2.1-.3 1-.2 1.2 1.2 1.4v.7h-4.5v-.7c1.3-.2 1.6-.4 2.2-2.1l4.1-10.3 1-.3c1.3 3.5 2.5 7 3.8 10.4.7 1.8.9 2 2.2 2.2v.7h-5.7zm-1.7-9.6h-.1c-.6 1.5-1.1 2.9-1.6 4.3h3.1l-1.4-4.3z",
  id: "logo-mobile_inline_svg__path871"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M243.2 28.1c-.2.9-.6 2.8-.7 3.4h-9.7v-.7c1.7-.1 1.9-.3 1.9-2v-7.7c0-1.7-.2-1.8-1.7-2v-.7h6.1v.7c-1.5.1-1.7.3-1.7 2v7.8c0 .9.1 1.3.5 1.5.4.1.9.2 1.5.2.9 0 1.6-.1 2.1-.7.4-.4.7-1 1.1-2.1l.6.3z",
  id: "logo-mobile_inline_svg__path873"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M77.9 46.4v-4.3H71v4.3h-1.9v-10H71v4.2h6.9v-4.2h1.9v10h-1.9z",
  id: "logo-mobile_inline_svg__path875"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M82.6 46.4v-10h9.1V38h-7.2v2.6H90v1.5h-5.5v2.8h7.2v1.6h-9.1z",
  id: "logo-mobile_inline_svg__path877"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M103.2 46.4l-1.3-2.5H96l-1.3 2.5h-2l5.4-10h1.6l5.5 10h-2zm-4.3-8l-2.2 4.2h4.4l-2.2-4.2z",
  id: "logo-mobile_inline_svg__path879"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M106.9 46.4v-10h1.9v8.4h7.8v1.6h-9.7z",
  id: "logo-mobile_inline_svg__path881"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M121.9 38v8.4H120V38h-4.4v-1.6h10.6V38h-4.3z",
  id: "logo-mobile_inline_svg__path883"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "logo-mobile_inline_svg__st0",
  d: "M137.2 46.4v-4.3h-6.9v4.3h-1.9v-10h1.9v4.2h6.9v-4.2h1.9v10h-1.9z",
  id: "logo-mobile_inline_svg__path885"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M263.4 49.6c0-5.2-.1-17.4-.1-27.1l-.2-17.8h2.6l.1 2.7c.1 1.5.2 13.7.2 27.1l.1 24.4h-2.7z",
  id: "logo-mobile_inline_svg__path891",
  fill: "#00467f",
  strokeWidth: 0.2
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M290.874 58.528c2.892-.2 4.278-1.038 5.421-3.279 1.573-3.083 1.003-5.823-2.25-10.805-1.213-1.859-2.41-3.38-2.66-3.38s-.453-.262-.453-.581c0-.32-2.005-3.245-4.454-6.5-9.011-11.97-11.001-17.934-7.805-23.388 1.518-2.59 4.732-4.686 7.108-4.636 1.736.037 1.759.055.526.424-2.826.846-5.457 4.595-5.91 8.421-.523 4.409 2.406 10.662 9.128 19.493 1.514 1.988 3 3.774 3.303 3.968.758.486 6.385 8.965 6.97 10.504.752 1.978.573 5.253-.372 6.803-1.305 2.14-4.156 3.303-7.856 3.204-2.892-.077-2.936-.093-.696-.248z",
  id: "logo-mobile_inline_svg__path1442",
  fill: "#000",
  fillOpacity: 0,
  strokeWidth: 0.445
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M290.874 58.528c2.892-.2 4.278-1.038 5.421-3.279 1.573-3.083 1.003-5.823-2.25-10.805-1.213-1.859-2.41-3.38-2.66-3.38s-.453-.262-.453-.581c0-.32-2.005-3.245-4.454-6.5-9.011-11.97-11.001-17.934-7.805-23.388 1.518-2.59 4.732-4.686 7.108-4.636 1.736.037 1.759.055.526.424-2.826.846-5.457 4.595-5.91 8.421-.523 4.409 2.406 10.662 9.128 19.493 1.514 1.988 3 3.774 3.303 3.968.758.486 6.385 8.965 6.97 10.504.752 1.978.573 5.253-.372 6.803-1.305 2.14-4.156 3.303-7.856 3.204-2.892-.077-2.936-.093-.696-.248z",
  id: "logo-mobile_inline_svg__path1444",
  fill: "#000",
  fillOpacity: 0,
  strokeWidth: 0.445
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M290.874 58.528c2.892-.2 4.278-1.038 5.421-3.279 1.573-3.083 1.003-5.823-2.25-10.805-1.213-1.859-2.41-3.38-2.66-3.38s-.453-.262-.453-.581c0-.32-2.005-3.245-4.454-6.5-9.011-11.97-11.001-17.934-7.805-23.388 1.518-2.59 4.732-4.686 7.108-4.636 1.736.037 1.759.055.526.424-2.826.846-5.457 4.595-5.91 8.421-.523 4.409 2.406 10.662 9.128 19.493 1.514 1.988 3 3.774 3.303 3.968.758.486 6.385 8.965 6.97 10.504.752 1.978.573 5.253-.372 6.803-1.305 2.14-4.156 3.303-7.856 3.204-2.892-.077-2.936-.093-.696-.248z",
  id: "logo-mobile_inline_svg__path1446",
  fill: "#000",
  fillOpacity: 0,
  strokeWidth: 0.445
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M313.032 43.945c-.362.363-.77.508-1.29.472-.395-.022-.515-.176-.573-.29-.543-1.05 1.215-4.248 3.07-7.212.078 3.03-.091 5.912-1.207 7.03zm-8.851 6.034c-.725.787-1.896 1.26-3.081 1.263l-.018.002c-1.087 0-2.084-.389-2.767-1.098-.931-.966-1.377-2.455-1.201-3.98.348-2.973 2.283-5.61 4.41-8.155l.594.83c2.55 3.54 5.44 7.551 2.063 11.118zm36.144-22.093a.374.374 0 00-.509.15c-.767 1.426-3.012 4.168-3.012 4.168-1.45 1.761-3.117 3.415-4.131 3.415-1.7 0-.504-3.08 1.692-7.998.18-.41.39-.93.667-.652.277.28.159 1.42.085 1.94l.747.107c.126-.9.012-3.573-.785-4.446a.958.958 0 00-.743-.33c-1.716.09-3.055 3.58-4.903 8.891l-1.957 5.132c-.593 0 2.397-8.984 1.518-10.506l-3.026-.906c-.55.031-1.163.493-1.812 1.196.3-1.573.363-2.238.054-2.388l-1.993-.885c-1.187-.543-3.261 3.021-4.39 5.192-.207.398-.674 1.123-1.27 1.993-.017-1.839.473-5.835.473-5.835l-2.592.062-.625 2.754c-.154.767-.677 1.966-1.395 3.017-.326.48-.667.97-1.087 1.377-.4.386-.957.616-1.45.296-.375-.245-.543-.92-.576-1.483-.07-.757.087-1.63.337-2.446l1.45-3.569h-2.175l-.177.174-2.313 4.051c-.882 1.77-2.246 3.432-3.727 5.164-3.588-4.88-8.292-9.875-9.422-15.873-.321-1.739.127-3.624.92-5.164.939-1.839 3.262-3.358 4.309-3.358 1.048 0 2.21.586 3.204 1.36 1.098.855 1.725 2.132 1.643 3.312-.005.081-.007.244.178.272l.335.05c.167.018.218-.01.232-.17.149-1.455-.598-3.03-1.924-4.063-2.42-1.884-5.393-2.083-7.973-.543-2.863 1.74-4.385 5.097-3.784 8.335.915 4.943 4.179 9.151 7.334 13.22 1.177 1.513 2.283 2.945 3.267 4.398l.036.055c-2.251 2.658-4.334 5.445-4.711 8.69-.205 1.747.32 3.443 1.404 4.592.826.857 2 1.328 3.312 1.328h.022c.5-.002 1.747 0 3.003-.319.674-.17 2.147-.732 2.817-1.44 4.132-4.35-.616-9.423-3.08-13.12l-.683-.978c1.504-1.754 3.004-3.564 3.946-5.449l.03-.065c-.224 1.214-.153 2.392.572 3.262.91 1.087 1.875 1.092 2.537.906 1.638-.426 3.073-2.474 3.836-4.168-.042.57-.052 1.141-.031 1.712l.054.943.123 2.301c-2.565 3.986-4.421 7.433-3.696 8.88.148.298.48.662 1.205.723.313.02 2.356-.032 3.483-.75 2.12-1.366 1.69-6.668 1.453-11.19l.036-.055c.859-1.29 1.54-2.309 1.825-2.863 1.304-2.508 2.854-4.715 3.363-4.845.284.906-1.098 6.23-2.537 10.988l2.65-.004s1.11-3.544 1.84-6.704c.843-1.269 1.635-2.115 2.198-2.148.073 0 .254-.012.46.363.069.133.11.278.124.427-.122 3.081-2.592 9.736-1.56 11.521.049.122.113.237.19.343.234.308.6.488.987.485 1.229.002 2.175-2.319 3.619-6.44.018.702.18 1.34.513 1.811.362.512.956.771 1.703.771 1.95 0 5.019-3.344 7.248-6.6 0 0 .833-1.269 1.163-1.863a.376.376 0 00.029-.29.37.37 0 00-.181-.223m2.4-7.254h15.95v2.218h-6.704v18.28h-2.577V22.83h-6.704zm22.734 0h3.132l6.92 20.498h-2.675l-1.761-5.219h-8.154l-1.761 5.22h-2.708zm-1.891 13.275h6.816l-3.392-10.11zm18.624 4.99h9.132v2.233h-11.71V20.612h2.578zm15.353-18.283v9.492l9.165-9.492h3.519l-8.97 9.231 9.54 11.285h-3.325l-7.925-9.492-2.022 2.088v7.404h-2.61V20.612z",
  fill: "#863e59",
  id: "logo-mobile_inline_svg__path2535"
});

function SvgLogoMobileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 488 63",
    id: "logo-mobile_inline_svg__svg901"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
}

export default SvgLogoMobileinline;